import PAYMENT_ORIGIN_ALL from 'constants/payment/paymentOriginAll.const';

// Payment origin serves to tell the BE what is the origin of the POS payment
// NOTE: It should use the same values as in PAYMENT_ORIGIN_ALL on request and let BE do the fine-tuning after

// SEE: https://getslick.atlassian.net/browse/GS-11130
// SEE: https://getslick.slack.com/archives/C017UAPSFJM/p1677168063020329?thread_ts=1677161154.847759&cid=C017UAPSFJM

const PAYMENT_ORIGIN_POS = Object.freeze({
  checkout: PAYMENT_ORIGIN_ALL.slickPos,
  deposit: PAYMENT_ORIGIN_ALL.slickPosDeposit,
  credit: PAYMENT_ORIGIN_ALL.slickPosDeposit,
  voucher: PAYMENT_ORIGIN_ALL.slickPosVoucher,
});

export default PAYMENT_ORIGIN_POS;
